module.exports = __webpack_public_path__ + "static/media/coin.e5483d3f.svg";